/**
 * Parses the raw PEP mini-objects JSON (the hotels the signed-in PEP user is authorized for) into a
 * normalized shape for the Users & devices popup.
 *
 * Returns `{ list, raw }` where:
 *   - `list` is `[{ id, name }]` best-effort, tolerant of camelCase/PascalCase keys
 *   - `raw`  is the pretty-printed JSON for the raw view (or the original string when not parseable)
 *
 * Never throws on malformed input: callers render the popup only when `raw` is non-empty.
 */
export function parseAccessibleHotels(accessibleHotelsJson) {
  const raw = accessibleHotelsJson == null ? '' : String(accessibleHotelsJson).trim()
  if (raw === '') {
    return { list: [], raw: '' }
  }

  try {
    const parsed = JSON.parse(raw)
    if (!Array.isArray(parsed)) {
      return { list: [], raw }
    }

    const list = parsed.map(hotel => {
      const entry = hotel && typeof hotel === 'object' ? hotel : {}
      const id = entry.id ?? entry.Id ?? entry.propertyId ?? entry.PropertyId ?? null
      const name = entry.name ?? entry.Name ?? entry.hotelName ?? entry.HotelName ?? null
      return {
        id: id == null ? null : String(id),
        name: name == null ? null : String(name)
      }
    })

    return { list, raw: JSON.stringify(parsed, null, 2) }
  } catch {
    return { list: [], raw }
  }
}
